var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoteTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-remote-track"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remote-track",
    clipPath: "url(#clip-remote-track)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_137",
    "data-name": "Group 137",
    transform: "translate(-45.335 -515.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M82.964,534.984H75.637l-5.495,16.484L59.154,518.5l-5.495,16.484H46.333",
    transform: "translate(0.807 0.726)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoteTrack);
export default __webpack_public_path__ + "static/media/remote-track.f049575d48c69fc8c42cd0acfd313414.svg";
export { ForwardRef as ReactComponent };